export default "__VITE_ASSET__B$w_SL3z__"